import React from "react";
import PropTypes from "prop-types";

function Button({
  label,
  type = "submit",
  status = "theme",
  disabled = false,
  onClick,
  icon,
}) {
  return (
    <button
      type={type}
      className={`btn button-${status} d-block  btn-lg w-inherit`}
      disabled={disabled}
      onClick={onClick}
    >
      {label}
      {"  "}
      <i className={"fa fa-" + icon}></i>
      {disabled && (
        <div class="spinner-border spinner-border-sm" role="status"></div>
      )}
    </button>
  );
}

Button.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  status: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  icon: PropTypes.string,
};

export default Button;
